var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "slide-show" },
    [
      _c(
        "flickity",
        {
          ref: "primarySlideshow",
          class: _vm.slideshowPrimaryClass,
          style: _vm.slideshowPrimaryStyle,
          attrs: {
            options: _vm.slideshowPrimaryOptions,
            role: "region",
            "aria-label": "Primary Slideshow"
          }
        },
        [_vm._t("primary")],
        2
      ),
      _vm.isMobile
        ? _c(
            "flickity",
            {
              ref: "secondarySlideshow",
              staticClass: "slideshow slideshow--secondary",
              style: _vm.slideshowSecondaryStyle,
              attrs: {
                options: _vm.slideshowSecondaryOptions,
                role: "region",
                "aria-label": "Primary Slideshow"
              }
            },
            [_vm._t("secondary")],
            2
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }